<template>
  <gg-modal :is-active="dialog" @close="close">
    <template v-slot:toolbar>Change document root</template>
    <template v-slot:body>
      <p>Document Root for: {{ selectedDomain.domain }}</p>
      <gg-text-field v-model="documentRoot"
                     label="Document Root"
                     name="Document Root"
                     v-validate="'required'"
                     :error-messages="errors.collect('Document Root')"
      />
    </template>
    <template v-slot:actions>
      <gg-btn secondary @click="close">Close</gg-btn>
      <gg-btn primary :loading="loading" @click="changeDocroot">Change</gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions } from 'vuex'
import modalMixin from '@/mixins/modal'

export default {
  name: 'ChangeDocRootModal',
  mixins: [modalMixin],
  props: {
    selectedDomain: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      loading: false,
      documentRoot: '',
    }
  },
  methods: {
    ...mapActions(['changeHostingDomainDocroot', 'reportError', 'reportSuccess']),
    async changeDocroot () {
      try {
        const isValid = await this.$validator.validateAll()

        if (!isValid) {
          return
        }
        this.loading = true
        const { subdomain, rootdomain } = this.selectedDomain
        const dir = this.documentRoot
        await this.changeHostingDomainDocroot({ subdomain, rootdomain, dir })

        this.reportSuccess(`Document Root Updated`)
        this.$emit('docroot-updated')
        this.close()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },
  },
  watch: {
    selectedDomain (val) {
      if (val) {
        this.documentRoot = val.basedir || ''
      } else {
        this.documentRoot = ''
      }
    },
  },
  created () {
    // register custom error message
    const dictionary = {
      custom: {
        'Document Root': {
          required: 'That directory is reserved for use by the system.',
        },
      },
    }
    this.$validator.localize('en', dictionary)
  }
}
</script>
